import { CSSProperties } from "@mui/styles/withStyles";
import InfiniteScroll from "react-infinite-scroll-component";
import { Spinner } from "./Common/Spinner";

interface Props {
  /**
   * Amount of items that has been fetched
   */
  itemsAmount: number;
  /**
   * Function to fetch new elements if `hasMore` is true
   */
  onFetch: () => void;
  /**
   * Flag to notify if there are remaining items to fetch
   */
  hasMore: boolean;
  /**
   * Function to render the components that will be scrolled. E.g. Item cards
   */
  renderFunction: () => JSX.Element[];
  /**
   * Style for infinite scroll container
   */
  style?: CSSProperties;
}

const defaultStyles: CSSProperties = { overflow: "hidden" };

const InfiniteScrollComponent = (props: Props) => {
  const styles = { ...defaultStyles, ...props.style };
  return (
    // @ts-ignore
    <InfiniteScroll style={styles} dataLength={props.itemsAmount} hasMore={props.hasMore} loader={<Spinner />} next={props.onFetch}>
      {props.renderFunction()}
    </InfiniteScroll>
  );
};

export default InfiniteScrollComponent;
